export default [
  'd8',
  'd9',
  'd10',
  'e6',
  'e7',
  'e8',
  'e9',
  'f6',
  'f7',
  'f8',
  'g6',
  'h5',
  'h6',
  'h7',
  'h8',
  'h9',
  'h10',
  'j5',
  'j6',
  'j7',
  'j8',
  'k5',
  'k6',
  'm6',
  'm7',
  'n6',
  'n7',
  'p6',
  'p7',
  'r6',
  's6',
  's7',
];
